  <template>
      <div id="userModal" class="modal modalFade userModels userLoginModal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
              <div class="modal-content">
                  <!-- Modal Header -->
                  <div class="modal-header">
                      <h5 class="modal-title">الدخول</h5>
                      <button type="button" class="btn-close" @click="closeLoginModal" aria-label="Close"></button>
                  </div>

                  <!-- Modal Body -->
                  <div class="modal-body">

                    <div class="icon_wrap">
                    <svg id="user_linear" data-name="user/linear" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                        <g id="vuesax_linear_user" data-name="vuesax/linear/user">
                          <g id="user">
                            <path id="Vector" d="M10,5A5,5,0,1,1,5,0,5,5,0,0,1,10,5Z" transform="translate(7 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                            <path id="Vector-2" data-name="Vector" d="M17.18,7c0-3.87-3.85-7-8.59-7S0,3.13,0,7" transform="translate(3.41 15)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                            <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                          </g>
                        </g>
                    </svg>

                </div>

                      <h3 class="icon_title">سجل برقم جوالك</h3>

                      <form @submit.prevent="handleLoginWrapper">
                          <!-- Phone Input -->
                          <div class="input-group">
                              <label for="login_mobile" class="input_label">أدخل رقم جوالك</label>
                              <input id="login_mobile" type="tel" placeholder="5xx xxx xxx" v-model="mobile"
                                  class="form-control mobile" minlength="9" maxlength="10" 
                                  @input="validateMobile" autofocus/>
                              <span v-if="errorMessage" class="has-error text-danger w-100">{{ errorMessage }}</span>

                              <div class="country_code">
                                  <img src="/website/assets/img/SaudiArabiaFlag.png" alt="Saudi Arabia Flag" />
                                  <span>+966</span>
                              </div>
                          </div>
                          <div class="input-group"></div>

                          <!-- Submit Button -->
                          <div class="input-group mb-0">
                              <button :disabled="isLoading || !!errorMessage" type="submit"
                                  class="form-control has-spinner-link" :class="{ loading: isLoading }">
                                  <div class="button_text">{{ isLoading ? 'جاري الإرسال...' : 'إرسال رمز التحقق' }}
                                  </div>
                              </button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>


  </template>

  <script setup lang="ts">
     import { ref, onMounted, nextTick, watch } from 'vue';

      import {
          useAuth
      } from '@/composables/useAuth';
      import {
          useBootstrapModal
      } from "@/composables/useBootstrapModal";

      // ✅ Dependency Injection
      const {
          mobile,
          errorMessage,
          isLoading,
          validateMobile,
          handleLogin
      } = useAuth();

      // Get modal control for both login and verify modals.
      const {
          closeModal: closeLoginModal
      } = useBootstrapModal("userModal");
      const {
          openModal: openVerifyModal
      } = useBootstrapModal("verifiyNewMobileModal");


      // Ref for login modal input
    const loginInput = ref(null);

    // Function to convert Arabic numbers to English
    const toEnglishNumber = (strNum) => {
    const arabicNumbers = '٠١٢٣٤٥٦٧٨٩';
    const englishNumbers = '0123456789';
    const arabicToEnglishMap = new Map([...arabicNumbers].map((num, index) => [num, englishNumbers[index]]));

    strNum = strNum.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (x) => arabicToEnglishMap.get(x) || x);
    strNum = strNum.replace(/[^\d]/g, ''); // Remove non-numeric characters
    return strNum;
    };

    // Watch for changes in `mobile` and convert numbers
    watch(mobile, (newValue) => {
    mobile.value = toEnglishNumber(newValue);
    });

      onMounted(() => {
        const modalElement = document.getElementById("userModal");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", () => {
                nextTick(() => {
                    const input = document.getElementById("login_mobile") as HTMLInputElement;
                    if (input) input.focus();
                });
            });
        }
    });

      // Wrap login handler to chain modal actions.
      const handleLoginWrapper = async () => {
        const success = await handleLogin();
        
        if (success) {
            closeLoginModal();
            setTimeout(() => {
                openVerifyModal();
            }, 300);
        }
    };

  </script>
